//qq浏览器定位
var util = require("../util");

var isInQQBrowser = function () {
    return ~navigator.userAgent.indexOf("MQQBrowser");
};

module.exports = function (suc, fail, next) {
    if (!isInQQBrowser()) {
        next();
    } else {

        util.loadScript("http://jsapi.qq.com/get?api=app.getGeoLocation", function () {
            try {
                browser.app.getGeoLocation(function (res) {
                    if (res.ret === "true") {
                        suc({
                            lat: res.latitude,
                            lng: res.longitude
                        });
                    } else {
                        fail.apply(this, Array.prototype.slice.call(arguments, 0));
                    }
                }, fail);
            } catch (e) {
                next();
            }
        });
    }

};


module.exports.type = "qqbrowser";


// WEBPACK FOOTER //
// ./~/@dp/whereami/lib/geos/qqbrowser.js